import { Droplet } from 'lucide-react'

export default function LoadingScreen() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4 animate-pulse">
          <Droplet className="w-8 h-8 text-white" />
        </div>
        <p className="text-blue-600 font-semibold text-sm">Loading PetroTrack…</p>
      </div>
    </div>
  )
}
